export default __webpack_public_path__ + "content/media/5.e920040a.jpg";